import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Services from './components/Services';
import Industries from './components/Industries';
import Footer from './components/Footer';
import ManagedSecurity from './components/pages/ManagedSecurity';
import SecurityOperationsCenter from './components/pages/SecurityOperationsCenter';
import CloudSecurity from './components/pages/CloudSecurity';
import ComplianceRisk from './components/pages/ComplianceRisk';
import Transformation from './components/pages/Transformation';
import SpecializedIndustry from './components/pages/SpecializedIndustry';
import ThreatIntelligence from './components/pages/ThreatIntelligence';
import IncidentResponse from './components/pages/IncidentResponse';
import DataSecurity from './components/pages/DataSecurity';
import TrainingAwareness from './components/pages/TrainingAwareness';
import ManagedServices from './components/pages/ManagedServices';
import ProfessionalServices from './components/pages/ProfessionalServices';
import GlobalDelivery from './components/pages/GlobalDelivery';
import GetStarted from './components/pages/GetStarted';
import Contact from './components/pages/Contact';
import About from './components/pages/About';
import WhyChooseUs from './components/pages/WhyChooseUs';
import Background3D from './components/Background3D';
import ServicesOverview from './components/pages/ServicesOverview';
import ConsultingOverview from './components/pages/ConsultingOverview';
import IndustriesOverview from './components/pages/IndustriesOverview';
import FinancialServices from './components/pages/industries/FinancialServices';
import Healthcare from './components/pages/industries/Healthcare';
import Government from './components/pages/industries/Government';
import Manufacturing from './components/pages/industries/Manufacturing';
import Retail from './components/pages/industries/Retail';
import Technology from './components/pages/industries/Technology';
import Education from './components/pages/industries/Education';
import Privacy from './components/pages/Privacy';
import Leadership from './components/pages/Leadership';
import Locations from './components/pages/Locations.tsx';
import Emergency911 from './components/pages/Emergency911.tsx';
import Terms from './components/pages/Terms';
import PulseSecurity from './components/pages/PulseSecurity';
import NeutronSecurity from './components/pages/NeutronSecurity';
import QuantumSecurity from './components/pages/QuantumSecurity';
import SecurityExcellence from './components/pages/SecurityExcellence';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedTheme = localStorage.getItem('theme');
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return savedTheme === 'dark' || (!savedTheme && prefersDark);
    }
    return false;
  });
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const [previousPage, setPreviousPage] = useState('home');

  useEffect(() => {
    if (currentPage !== previousPage) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      setPreviousPage(currentPage);
    }
  }, [currentPage, previousPage]);

  useEffect(() => {
    const root = window.document.documentElement;
    if (darkMode) {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.add('light');
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const renderPage = () => {
    switch (currentPage) {
      case 'managed-security':
        return <ManagedSecurity setCurrentPage={setCurrentPage} />;
      case 'soc':
        return <SecurityOperationsCenter setCurrentPage={setCurrentPage} />;
      case 'cloud-security':
        return <CloudSecurity setCurrentPage={setCurrentPage} />;
      case 'compliance':
        return <ComplianceRisk setCurrentPage={setCurrentPage} />;
      case 'transformation':
        return <Transformation setCurrentPage={setCurrentPage} />;
      case 'specialized-industry':
        return <SpecializedIndustry setCurrentPage={setCurrentPage} />;
      case 'threat-intelligence':
        return <ThreatIntelligence setCurrentPage={setCurrentPage} />;
      case 'incident-response':
        return <IncidentResponse setCurrentPage={setCurrentPage} />;
      case 'data-security':
        return <DataSecurity setCurrentPage={setCurrentPage} />;
      case 'training':
        return <TrainingAwareness setCurrentPage={setCurrentPage} />;
      case 'managed-services':
        return <ManagedServices setCurrentPage={setCurrentPage} />;
      case 'professional-services':
        return <ProfessionalServices setCurrentPage={setCurrentPage} />;
      case 'global-delivery':
        return <GlobalDelivery setCurrentPage={setCurrentPage} />;
      case 'get-started':
        return <GetStarted />;
      case 'contact':
        return <Contact />;
      case 'about':
        return <About setCurrentPage={setCurrentPage} />;
      case 'why-choose-us':
        return <WhyChooseUs setCurrentPage={setCurrentPage} />;
      case 'solutions':
        return <Solutions />;
      case 'services-overview':
        return <ServicesOverview setCurrentPage={setCurrentPage} />;
      case 'consulting-overview':
        return <ConsultingOverview setCurrentPage={setCurrentPage} />;
      case 'industries-overview':
        return <IndustriesOverview setCurrentPage={setCurrentPage} />;
      case 'industries':
        return <Industries />;
      case 'financial-services':
        return <FinancialServices setCurrentPage={setCurrentPage} />;
      case 'healthcare':
        return <Healthcare setCurrentPage={setCurrentPage} />;
      case 'government':
        return <Government setCurrentPage={setCurrentPage} />;
      case 'manufacturing':
        return <Manufacturing setCurrentPage={setCurrentPage} />;
      case 'retail':
        return <Retail setCurrentPage={setCurrentPage} />;
      case 'technology':
        return <Technology setCurrentPage={setCurrentPage} />;
      case 'education':
        return <Education setCurrentPage={setCurrentPage} />;
      case 'privacy':
        return <Privacy />;
      case 'leadership':
        return <Leadership />;
      case 'locations':
        return <Locations setCurrentPage={setCurrentPage} />;
      case '911-astronshield':
        return <Emergency911 setCurrentPage={setCurrentPage} />;
      case 'terms':
        return <Terms />;
      case 'pulse-security':
        return <PulseSecurity setCurrentPage={setCurrentPage} />;
      case 'neutron-security':
        return <NeutronSecurity setCurrentPage={setCurrentPage} />;
      case 'quantum-security':
        return <QuantumSecurity setCurrentPage={setCurrentPage} />;
      case 'security-excellence':
        return <SecurityExcellence setCurrentPage={setCurrentPage} />;
      default:
        return (
          <>
            <Hero setCurrentPage={setCurrentPage} />
            <Solutions setCurrentPage={setCurrentPage} />
            <Services setCurrentPage={setCurrentPage} />
            <Industries setCurrentPage={setCurrentPage} />
          </>
        );
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-200`}>
      <Background3D />
      <Navigation 
        darkMode={darkMode} 
        setDarkMode={setDarkMode}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        setCurrentPage={setCurrentPage}
      />
      <main>
        {renderPage()}
      </main>
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
}

export default App;